// extracted by mini-css-extract-plugin
export default {"root":"rX6Ma_"};